export default __webpack_public_path__ + "static/media/arras17.894c57a0.jpg";